import { io } from "socket.io-client";

export const socket = io("https://fuelclubs-7e1de6237c90.herokuapp.com", {
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});